export enum NewsletterEditionStatus {
  Approved = 'approved',
  Draft = 'draft',
  Published = 'published',
  Skipped = 'skipped',
}

export const NEWSLETTER_EDITION_STATUS_I18N: Record<NewsletterEditionStatus, string> = {
  [NewsletterEditionStatus.Approved]: 'Geprüft',
  [NewsletterEditionStatus.Draft]: 'Entwurf',
  [NewsletterEditionStatus.Published]: 'Veröffentlicht',
  [NewsletterEditionStatus.Skipped]: 'Übersprungen',
};
